import { render, staticRenderFns } from "./BrandIdBlock.vue?vue&type=template&id=e6f75c92&scoped=true"
import script from "./BrandIdBlock.vue?vue&type=script&lang=js"
export * from "./BrandIdBlock.vue?vue&type=script&lang=js"
import style0 from "./BrandIdBlock.vue?vue&type=style&index=0&id=e6f75c92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6f75c92",
  null
  
)

export default component.exports